export default __webpack_public_path__ + "static/media/7.884e0b8a.jpg";